"use client";

import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import Container from "../Container";
import GoogleSignUpForm from "../GoogleForm";
import FacebookSignUpForm from "../FacebookForm";
import UserDataForm from "../UserDataForm";

const UserInfo = () => {
  const [layout, setLayout] = useState({
    google: true,
    facebook: true,
    normal: true,
  });

  const layoutHandler = (layout: string) => {
    setLayout((prevState) => ({
      google: false,
      facebook: false,
      normal: false,
      [layout]: true,
    }));
  };

  const showAllHandler = () => {
    setLayout((prevState) => ({
      google: true,
      facebook: true,
      normal: true,
    }));
  };

  return (
    <Container>
      {/* <Box sx={{ display: "flex", gap: 2 }}>
        {layout?.google && (
          <GoogleSignUpForm
            layoutHandler={layoutHandler}
            showAllHandler={showAllHandler}
          />
        )}

        {layout?.facebook && (
          <FacebookSignUpForm
            layoutHandler={layoutHandler}
            showAllHandler={showAllHandler}
          />
        )}
      </Box> */}

      {/* {layout?.google && layout?.facebook && layout?.normal && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Divider sx={{ flex: 1, borderColor: "#CAC4D0" }} />
          <Typography
            sx={{
              mx: 2,
              color: "#49454F",
              fontSize: 11,
              fontFamily: "SF Pro",
              fontWeight: 500,
              letterSpacing: "0.5px",
            }}
          >
            or sign up with
          </Typography>
          <Divider sx={{ flex: 1, borderColor: "#CAC4D0" }} />
        </Box>
      )} */}

      {layout?.normal && (
        <UserDataForm
          layoutHandler={layoutHandler}
          showAllHandler={showAllHandler}
        />
      )}
    </Container>
  );
};

export default UserInfo;
